<template>
  <div class="c-context-select__single-selection">
    <content-loader :is-loading="isLoading" layout="context-layout" :single-selector="true">
      <template v-slot:content>
        <ul class="c-context-select__single-selection-list">
          <li class="c-context-select__single-selection-item" :key="`${option.type}-${option.id}`" v-for="option in options">
            <label class="c-context-select__single-selection-label" :id="option.id">
              <input type="radio" @change="onSelectChange(option)" v-model="selectedOption().key" :value="`${option.type}-${option.id}`" :disabled="option.isDisabled">
              <div class="c-context-select__single-selection-text">
                <div class="c-context-select__single-selection-info">
                  <abbr class="c-context-select__single-selection-title" :title="[option.policy.businessName, option.policy.merchantName].filter(Boolean).join(' > ')">
                    <span class="sm-down:truncate sm-down:block" :class="[{ 'font-semibold': typeof option.policy.merchantId === 'undefined' }]">
                      {{ option.policy.businessName }} {{ option.policy.merchantId ? ' > ' : '' }}
                    </span>
                    <span v-if="option.policy.merchantId" class="sm-down:truncate sm-down:block font-semibold">
                      {{ option.policy.merchantName }}
                    </span>
                  </abbr>
                  <div class="c-context-select__single-selection-id">{{ option.id }}</div>
                </div>
                <div class="c-context-select__single-selection-type">
                  {{ $t(`label.${option.type}`) }}
                </div>
                <div class="c-context-select__single-selection-icons">
                  <favorite-selection :policy="option.policy" :favorite-items="favoriteItems" @add-favorite="addFavorite" @remove-favorite="removeFavorite" />
                </div>
              </div>
            </label>
          </li>

          <li v-if="isLoading === false && items.length === 0" class="c-context-select__single-selection-item c-context-select__single-selection-item--is-empty" >
            <slot name="is-empty">
              {{ $t('sentence.noRecords') }}
            </slot>
          </li>
        </ul>

        <base-pagination class="p-2" :pagination="pagination" @change="$emit('page-number-select', $event)" :show-page-size-select="false" :is-compact="true"/>
      </template>
    </content-loader>
  </div>
</template>

<script>
import { favorite } from '@/views/Context/Mixins'

import FavoriteSelection from '@/views/Context/Components/FavoriteSelection'

import ContentLoader from '@/components/ContentLoader/ContentLoader.vue'

export default {
  name: 'SingleSelectionList',

  components: { FavoriteSelection, ContentLoader },

  mixins: [ favorite ],

  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      default: () => ({
        pageNumber: 1,
        pageSize: 10,
        totalCount: 0
      })
    }
  },

  created () {
    this.$store.dispatch('removeSelections')
  },

  computed: {
    options () {
      return this.items.map(item => typeof item.merchantId !== 'undefined'
      ? { type: 'merchant', id: item.merchantId, policy: { ...item }, isDisabled: this.$store.state.context.minimumSelections.length > 2 }
      : { type: 'business', id: item.businessId, policy: { ...item }, isDisabled: this.$store.state.context.minimumSelections.length > 1 })
    }
  },

  methods: {
    selectedOption () {
      const { business = { id: null }, merchant = { id: null } } = this.$store.state.context.selections.reduce((result, item) => ({ ...result, [item.key]: item.policy }), {})

      return merchant && merchant.id ? { ...merchant, key: `merchant-${merchant.id}` } : business && business.id ? { ...business, key: `business-${business.id}` } : { id: null }
    },

    onSelectChange ({ policy }) {
      const { businessId, businessName, merchantId, merchantName } = policy

      this.$store.dispatch('setSelection', { key: 'business', policy: { id: businessId, title: businessName } })
      this.$store.dispatch('setSelection', { key: 'merchant', policy: merchantId ? { id: merchantId, title: merchantName } : { id: null } })
    }
  }
}
</script>
